import { field } from 'theme/form';
export default {
  field,
};
